import { render, staticRenderFns } from "./Viphosts_dialog.vue?vue&type=template&id=4b8780c3&scoped=true&"
import script from "./Viphosts_dialog.vue?vue&type=script&lang=js&"
export * from "./Viphosts_dialog.vue?vue&type=script&lang=js&"
import style0 from "./Viphosts_dialog.vue?vue&type=style&index=0&id=4b8780c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8780c3",
  null
  
)

export default component.exports